<template>
  <div
    id="app"
    ref="app"
    :class="[
      $mq,
      $route.name,
      themeVariant
    ]"
    :style="cssProps"
  >
    <vue-progress-bar />

    <div
      v-if="['mobile', 'tablet'].includes($mq)"
      class="dashGround"
    ></div>

    <div
      v-if="env === 'local'"
      class="mq"
    >
      {{ $mq }}
    </div>
    <transition
      name="el-fade-in"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',

  computed: {
    env() {
      return process.env.VUE_APP_ENV;
    },

    ...mapGetters('user', {
      theme: 'getTheme',
    }),

    cssProps() {
      if (process.env.VUE_APP_SERVICE === 'gcg_platform' && this.theme) {
        return {
          backgroundImage: this.theme.background_color,
          '--themeFontColor': this.theme.is_dark === false ? '#303133' : 'white',
          '--themeCardColor': this.theme.is_dark === false ? 'rgba(0, 0, 0, 0.04)' : 'rgba(255, 255, 255, 0.2)',
          '--themeThinTitleColor': this.theme.is_dark === false ? '#0096C6' : '#09eacf',
        };
      }
      return {
        '--themeFontColor': 'white',
        '--themeCardColor': 'rgba(255, 255, 255, 0.2)',
        '--themeThinTitleColor': '#09eacf',
      };
    },

    themeVariant() {
      if (!this.theme.is_dark) return 'light';
      return 'dark';
    },
  },

  mounted() {
    this.$Progress.finish();

    // Responsive custom 'vh' property '--vh' for mobile toolbar
    // Set automatic reaction nextTick
    this.setVh();
    window.addEventListener('resize', this.setVh);
    // adding a new event listener on every DOM update doesn't seems necessary here
    // (but keep in comment just in case something goes wrong...)

    // this.$nextTick(() => {
    //   window.addEventListener('resize', () => {
    //     this.setVh();
    //   });
    // });
  },

  created() {
    this.$Progress.start();

    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      next();
    });

    this.$router.afterEach(() => {
      this.$Progress.finish();
    });

    if (process.env.VUE_APP_APP_NAME) {
      document.title = process.env.VUE_APP_APP_NAME;
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setVh);
  },

  methods: {
    setVh() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat:500,500i,700&display=swap');

// Necessary scss property for el-element
$tablet: 899px;

* {
  // For only iOS
  @supports (-webkit-overflow-scrolling: touch) {
    // // It's block ios blinking problem but also causes fixed browser toolbar, modal
    // -webkit-overflow-scrolling: touch;

    // // For iOS layout issue, forced size change block
    -webkit-text-size-adjust: none !important;
  }
}

body {
  min-width: 320px;
  margin: 0;
  background: #212121;
}

.defaultCursor {
  cursor: default;
}

.mq {
  color: white;
  background: red;
  text-align: center;
  display: inline-block;
  padding: 5px;
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 999999;
}

#app {
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  min-height: 100vh;
  // background-image: radial-gradient(circle at bottom left, #2dc0c7, #32166b);
  background-image: radial-gradient(circle at bottom left, #28aeb5, #2b145f);
  background-size: cover;
  background-attachment: fixed;

  // &.mobile,
  // &.tablet {
  //   background: none;
  // }

  // @media (prefers-color-scheme: dark) {
  //   // DARK MODE
  //   background-image: radial-gradient(circle at bottom left, #383838, black);
  // }

  .dashGround {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: -1;
    overflow: hidden;
    // background-image: radial-gradient(circle at bottom left, #2dc0c7, #32166b);
    background-image: radial-gradient(circle at bottom left, #28aeb5, #2b145f);
    background-size: 100vw 100vh;
  }
}

.customTransition-enter-active,
.customTransition-leave-active {
  transition: all 150ms ease-in-out;
  z-index: 9000;
}

.customTransition-enter,
.customTransition-leave-to {
  opacity: 0;
  z-index: 9000;
}

.el-input .el-input__inner,
.el-textarea .el-textarea__inner {
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
  line-height: 22px;
}

.el-button {
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;

  // &.el-button--primary {
  //   color: var(--themeFontColor);
  // }

  &.is-round {
    padding: 13px 23px;
  }
}

.el-input.clearInput {
  input {
    background-color: transparent;
    color: var(--themeFontColor);
    border: none;
    border-radius: 0;
    padding: 0 2px;
  }

  .el-input-group__append {
    background-color: transparent;
    border: none;
    color: var(--themeFontColor);
    font-size: 16px;
    padding: 0 20px 0 5px;

    .el-button {
      padding: 5px;
    }
  }
}

// Require field asterisk
.el-form {
  .el-form-item.is-required {
    .el-form-item__label {
      cursor: default;

      &::before {
        display: none;
      }

      &::after {
        content: '*';
        color: #f56c6c;
        margin-left: 4px;
      }
    }
  }
}

// transparent card
.el-card.clear-card {
  background-color: var(--themeCardColor);
  border-width: 0;
  color: var(--themeFontColor);

  .el-card__header {
    border-bottom-color: var(--themeFontColor);
    .title {
      cursor: default;
    }
  }

  label {
    color: var(--themeFontColor);
  }

  .el-form {
    .el-form-item {
      margin-bottom: 30px;
    }

    .el-form-item__label {
      line-height: 20px;
      font-size: 16px;
    }

    .el-input .el-input__inner {
      background-color: transparent;
      color: var(--themeFontColor);
      border-radius: 0;
      border-top-width: 0;
      border-left-width: 0;
      border-right-width: 0;
      font-size: 16px;
      font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;

      @media (max-width: $tablet) {
        font-size: 18px;
      }
    }

    .el-input__suffix .el-input__suffix-inner {
      font-size: 16px;
    }
  }
}

// transparent tabs
.el-tabs.clear-tabs {
  border-width: 0;
  color: var(--themeFontColor);
  background-color: unset;
  border-radius: 10px;

  .el-tabs__header {
    background-color: unset;
    border-bottom-width: 0;

    .el-tabs__nav-wrap {
      margin-bottom: unset;
      // border-top-left-radius: 10px;
      // border-top-right-radius: 10px;

      .el-tabs__nav {
        .el-tabs__item {
          margin-top: unset;
          margin-left: unset;
          height: 100%;
          border-width: 0;
          color: #bcbcbc;
          background-color: rgba(255, 255, 255, 0.1);
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          line-height: 30px;
          padding-top: 5px;
          padding-bottom: 5px;

          &.is-active {
            background-color: var(--themeCardColor);
            color: var(--themeFontColor);
          }
        }
      }
    }
  }

  .el-tabs__content {
    background-color: var(--themeCardColor);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}

// transparent table
.el-table {
  /* stylelint-disable */
  tr.hover-row > td,
  tr.hover-row.current-row > td,
  tr.hover-row.el-table__row--striped > td,
  tr.hover-row.el-table__row--striped.current-row > td {
    background-color: rgba(255, 255, 255, 0) !important;
  }

  &.clear-table {
    color: var(--themeFontColor);
    // background-color: rgba(255, 255, 255, 0.2);
    background-color: var(--themeCardColor);
    // border-radius: 4px;
    border-radius: 10px;

    &:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .el-table__empty-text {
      color: var(--themeFontColor);
    }

    th {
      background-color: rgba(255, 255, 255, 0);
      &.is-leaf {
        border-bottom-color: var(--themeFontColor);
      }
    }

    td {
      border-bottom-width: 0;
      background-color: rgba(255, 255, 255, 0);
    }

    tr {
      background-color: rgba(255, 255, 255, 0);

      &:hover > td {
        background-color: rgba(255, 255, 255, 0.15) !important;
      }
    }

    .el-table__row {
      height: 60px;
    }

    .hover-row {
      background-color: rgba(255, 255, 255, 0.15);
    }

    .cell {
      word-break: break-word;
    }

    &::before {
      width: 0;
    }
  }
  /* stylelint-enable */
}

//notification
.el-notification {
  max-width: 90%;

  .el-notification__title {
    font-weight: normal;
  }

  &.right {
    .el-notification__group {
      width: 100%;
      word-break: break-word;
      font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
    }
  }
}

.el-notification .el-notification__icon.el-icon-bell {
  color: gold;
}

.el-page-header {
  color: var(--themeFontColor);
  margin-bottom: 20px;

  .el-page-header__left {
    margin-right: 0;

    &::after {
      height: 0;
    }
  }

  .el-page-header__content {
    color: var(--themeFontColor);
  }
}

.el-pagination {
  margin-top: 30px;
  text-align: center;

  .el-pager li {
    background-color: transparent;
    color: var(--themeFontColor) !important;
  }

  .el-pager li.active {
    text-decoration: underline;
  }

  .btn-prev,
  .btn-next {
    background-color: transparent !important;
    color: var(--themeFontColor) !important;
  }

  .el-icon-arrow-left,
  .el-icon-arrow-right {
    padding-top: 2px;
  }
}

.el-dialog {
  border-radius: 10px !important;
  margin-bottom: 10vh !important;

  .el-dialog__header {
    .el-dialog__headerbtn {
      top: 15px;
      right: 15px;
    }
  }

  .el-dialog__body {
    max-height: calc((var(--vh, 1vh) * 80) - 150px);
    overflow-y: auto;
    word-break: break-word;
  }
}

.el-tooltip__popper {
  max-width: 200px;
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
  cursor: default;
}

.el-message {
  width: 90%;
  max-width: 500px;
  min-width: 290px !important;
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
}

.el-drawer__header {
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
}

.el-message-box__wrapper {
  .el-message-box {
    max-width: 90%;
    font-size: 16px;
    font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
    padding: 20px 25px 25px;
    box-sizing: border-box;

    .el-message-box__header {
      padding: 0 0;

      .el-message-box__title {
        padding-bottom: 15px;
      }

      .el-message-box__headerbtn {
        display: none;
      }
    }

    .el-message-box__content {
      padding: 0;

      .el-message-box__message {
        font-size: 16px;
      }
    }

    .el-message-box__btns {
      padding: 20px 0 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;

      .el-button {
        font-size: 14px;
        border-radius: 20px;
        width: 100px;
        max-width: 100%;
        padding: 11px 0;

        @media (max-width: $tablet) {
          width: 100%;
          margin: 0;

          &:not(:last-child) {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

.el-select {
  input.el-input__inner {
    border-radius: 20px;
  }
}

.el-select-dropdown {
  max-width: 98%;

  .el-select-dropdown__item {
    font-size: 14px;
    font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
  }
}

.el-picker-panel {
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
}

// vuejs date picker
.vdp-datepicker {
  .cell.day {
    height: 14.285714285714286%;
    word-break: keep-all;
  }

  .cell.day.selected {
    // background: #005246;
    background: #409eff;
    border-radius: 50%;
    box-sizing: border-box;
    color: white;

    &:hover {
      background: #409eff;
      border-color: #409eff !important;
    }
  }

  .cell.day:hover {
    border-radius: 50%;
    border-color: #409eff !important;
  }
}

.appcues-powered-by-badge {
  visibility: hidden;
}

//perfect scrollbar
.ps .ps__rail-x:hover,
.ps .ps__rail-y:hover,
.ps .ps__rail-x:focus,
.ps .ps__rail-y:focus,
.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-y.ps--clicking {
  background-color: transparent !important;
}

// Theme variant
#app.light {
  .el-button--default {
    border-color: var(--themeFontColor);
  }
}
</style>
